module.exports = __webpack_public_path__ + "img/8@3x.ce08f9e2.png";